import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconChevronLeft = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-chevron-left" data-icon="icon-chevron-left" aria-hidden="true" {...props} ref={ref}><polyline points="15 18 9 12 15 6"/></svg>);
});

IconChevronLeft.displayName = 'IconChevronLeft';
